<script>
    export let subject = '';
    export let text = '';
    export let bg = '';
</script>

<div class="visual" style="background-image: url({bg});">
    <p class="visual__subject">{@html subject}</p>
    <p class="visual__text">{@html text}</p>
</div>

<style>
    .visual {
        background: #333;
        padding: 20px;
        background-position: left 30% center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        height: 60vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .visual__subject {
        margin-top: -15vh;
        color: #fff;
        font-size: 40px;
        font-weight: 700;
    }
    .visual__text {
        margin-top: 10px;
        color:#fff;
        font-size: 20px;
        font-weight: 500;
    }

</style>